<script setup lang="ts">
import { onMounted, useTemplateRef, watch } from 'vue'

import { ResultId } from '@collector/sportsapi-client-legacy'
import { useParticipantResult } from '@desktop/views/Relation/composables'
import { useElementSize } from '@vueuse/core'

interface Props {
  currentResultId?: ResultId
  resultAcronym: string
  resultId: ResultId
}

const props = defineProps<Props>()

type Emits = { widthCalculated: [number] }
const emit = defineEmits<Emits>()

const resultItemElement = useTemplateRef('resultItemElement')
const { width: resultWidth } = useElementSize(resultItemElement)

const { getHomeParticipantResult, getAwayParticipantResult } =
  useParticipantResult()

onMounted(() => {
  emit('widthCalculated', resultWidth.value)
})

watch(resultWidth, (newWidth) => {
  emit('widthCalculated', newWidth)
})
</script>

<template>
  <div
    ref="resultItemElement"
    class="text-center"
    :class="{
      'font-bold': resultId === currentResultId,
    }"
  >
    {{ resultAcronym }}
    <span>(</span>
    <span>
      {{ getHomeParticipantResult(props.resultId) }}
    </span>
    <span class="mx-1">:</span>
    <span>
      {{ getAwayParticipantResult(props.resultId) }}
    </span>
    <span>)</span>
  </div>
</template>
